import React from 'react'

const Index = () => {
  return (
    <div>
      <section className='row  '>
        <div className='card h-800px '>
          <iframe
            title='botgo dashboard version2'
            className='h-800px '
            src='https://app.powerbi.com/reportEmbed?reportId=e4c35cf3-6601-4a66-b6ce-33d908a1dc30&autoAuth=true&embeddedDemo=true'
          ></iframe>
        </div>
      </section>
    </div>
  )
}

export default Index
